import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';
import {
	COLUMN_SORT_STATE,
	COLUMN_SORT_STATE_PREFIX,
	ColumnName,
	ColumnState,
	SYMBOL_DETAILS_OPTIONS
} from '../configs/symbol-details-config';
import { LocalStorageService } from '@easy-lib/modules/shared/services';

@Injectable({
	providedIn: 'root'
})
export class SymbolDetailsComponentsOrderService {
	isStockDetailsAvailable = new BehaviorSubject<boolean>(false);
	isStockDetailsAvailable$ = this.isStockDetailsAvailable.asObservable();
	columnState = new BehaviorSubject<ColumnState[]>(undefined);
	columnState$ = this.columnState.asObservable().pipe(filter(Boolean));

	constructor(private readonly localStorageService: LocalStorageService) {
		const oldKeys = [];
		for (let i = 0, len = localStorage.length; i < len; ++i) {
			if (localStorage.key(i).includes(COLUMN_SORT_STATE_PREFIX) && localStorage.key(i) !== COLUMN_SORT_STATE) {
				oldKeys.push(localStorage.key(i));
			}
		}
		oldKeys?.forEach(x => localStorage.removeItem(x));
		const columns = JSON.parse(localStorageService.getItem(COLUMN_SORT_STATE)) as ColumnState[];
		this.columnState.next(columns || [...SYMBOL_DETAILS_OPTIONS]);

		this.columnState$.subscribe(columns => {
			this.updateOrders(columns);
		});
	}

	getPosition(id: ColumnName): number {
		const columns = this.columnState.value;
		const column = columns.find(c => c.id == id);
		return column ? column.index : -1;
	}

	getTitle(id: ColumnName) {
		const columns = this.columnState.value;
		const column = columns.find(c => c.id == id);
		return column.title;
	}

	updateOrders(cols: ColumnState[]) {
		this.localStorageService.setItem(COLUMN_SORT_STATE, JSON.stringify(cols));
	}

	changeVisibilityItem(id: ColumnName) {
		const columns = this.columnState.value;
		const column = columns.find(c => c.id == id);
		column.isExpand = !column.isExpand;
		this.localStorageService.setItem(COLUMN_SORT_STATE, JSON.stringify(columns));
	}

	getVisibilityItem(id: ColumnName) {
		const columns = this.columnState.value;
		const column = columns.find(c => c.id == id);
		return column.isExpand;
	}
}
